// frontend/src/services/reportingObserver.js
// ReportingObserver：收集瀏覽器 deprecation / intervention 報告並回傳 CSP report endpoint
// （csp-violation 不經此路徑，規範上由 nginx report-uri 直接投遞，見計劃書 Step 5）

export function setupReportingObserver() {
  // 舊瀏覽器無此 API，靜默跳過
  if (!('ReportingObserver' in window)) return;

  const observer = new window.ReportingObserver(
    (reports) => {
      reports.forEach((report) => {
        const payload = JSON.stringify({
          type: 'reporting-observer',
          reportType: report.type,
          url: report.url,
          body: report.body ? JSON.parse(JSON.stringify(report.body)) : null,
        });
        // sendBeacon 傳字串會變 text/plain 被 parser 拒收，必須用 Blob 指定 content-type
        navigator.sendBeacon('/api/csp-report', new Blob([payload], { type: 'application/json' }));
      });
    },
    { types: ['deprecation', 'intervention'], buffered: true }
  );

  observer.observe();
}
